import { MessageBox, Row, Col, Button, Input, Loading, Dialog } from 'element-ui'
import { GetUserSig } from "@/utils/api.js"
window.GetUserSig = GetUserSig
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import iView from 'iview';
import SHA1 from 'sha1'
import 'iview/dist/styles/iview.css';
import { getCookie } from "@/utils/common.js"
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Print from '@/utils/print.js'
import 'lib-flexible'
import '@/utils/directives'
import tim from './tim'
import TIM from 'tim-js-sdk'
import './assets/icon/iconfont.css'
import './assets/icon/tim.css'
import Fingerprint2 from 'fingerprintjs2'
Vue.use(Print) // 注册
Vue.use(Viewer);
Vue.use(iView);
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(SHA1)
Vue.prototype.$store = store;
Vue.prototype.$Fingerprint = Fingerprint2;
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。
window.tim = tim
window.TIM = TIM
Vue.prototype.tim = tim
Vue.prototype.TIM = TIM

Viewer.setDefaults({
    Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
Vue.config.productionTip = false
router.beforeEach((to, form, next) => {
    if (to.path == '/login') {
        next();
    } else if (!(getCookie('access_token'))) {
        next('/login'); //转入login登录页面，登录成功后会将token存入localStorage
    } else {
        next()
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')